import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DynamicFormComponent } from '../dynamic-form/dynamic-form.component';
import { BaseService } from 'src/app/core/services/base.service';
import * as XLSX from 'xlsx';
import { MatStepper } from '@angular/material/stepper';

@Component({
  selector: 'optsol-ngx-data-import-2',
  templateUrl: './data-import-2.component.html',
  styleUrls: ['./data-import-2.component.scss']
})
export class DataImportComponent2 implements OnInit {
  @Input() config: any;
  @Input() tableHeight: any;
  @Output() submissionResponse: EventEmitter<any> = new EventEmitter<any>();
  @Output() matStepperSelectionChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() close: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild(DynamicFormComponent) dynamicFormComponent;

  tableConfig: any;
  tableData: any;

  alteredFormValue: any

  constructor(
    private baseService: BaseService,
  ) { }

  async ngOnInit(): Promise<void> {
    this.baseService.executeCommand(this.config.tableConfigProc, {})
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.tableConfig = response.data;
        }
      });
  }

  formSubmitted(stepper: MatStepper) {
    // There is a limitation where we only support data files to be uploaded.
    // Currently we can't do an image and an excel file for example
    let propertyNamesToReplace = this.dynamicFormComponent.formFields.filter(f => f.type === 'files').map(m => m.name);
    this.alteredFormValue = this.dynamicFormComponent.value;
    for (let propertyNameToReplace of propertyNamesToReplace) {
      let uploadedFileJson = this.convertXLSXToJson(this.dynamicFormComponent.value[propertyNameToReplace][0]);
      this.alteredFormValue[propertyNameToReplace] = JSON.parse(uploadedFileJson);
    }

    this.baseService.executeCommand(this.config.dataImportFormJson.apiFunction, this.alteredFormValue)
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.tableData = response.data;
          stepper.next();
        }
      });
  }

  convertXLSXToJson(file: any) {
    if (!file) return null;
    let workBook = XLSX.read(file.base64, { type: 'base64' });
    let jsonData = workBook.SheetNames.reduce((initial, name) => {
      const sheet = workBook.Sheets[name];
      initial[name] = XLSX.utils.sheet_to_json(sheet, { raw: false });
      return initial[name];
      // return initial; -> This returns all sheets, we just support 1
    }, {});
    return JSON.stringify(jsonData);
  }

  resetImportData() {
    console.log('this.dynamicFormComponent before: ', this.dynamicFormComponent);
    this.tableData = null;
    this.dynamicFormComponent.reset();
    console.log('this.dynamicFormComponent after: ', this.dynamicFormComponent);
  }

  actionButtonClicked(action: any) {
    this.baseService.executeCommand(action.actionProc, { actionCode: action.actionCode, data: this.tableData, ...this.dynamicFormComponent.form.value })
      .subscribe(response => {
        this.submissionResponse.emit(response);
      });
  }

  // Emit the stepper selection change event so the parent component 
  // can change the size of the dialog based on which step we're on
  matStepperSelectionChanged(event: any) {
    this.matStepperSelectionChange.emit(event);
  }

  get formValid(): boolean {
    if (!this.dynamicFormComponent || !this.dynamicFormComponent.form) return false;
    return this.dynamicFormComponent.form.valid;
  }

  closeClicked() {
    this.close.emit(true);
  }
}
